import React, { useCallback, useRef } from "react";
import Button from "../../../form/Button";
import { classNames } from "../../../../helpers/classNames";

const SectionTable = ({
  data,
  setFilters,
  timelineLoading,
  scholarshipData,
}) => {
  const observer = useRef();

  const loadMoreRef = useCallback(
    (node) => {
      if (timelineLoading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && scholarshipData?.metadata?.nextPage) {
          setFilters((prev) => ({
            ...prev,
            page: prev.page + 1,
          }));
        }
      });

      if (node) observer.current.observe(node);
    },
    [timelineLoading]
  );

  return (
    <>
      <div className="space-y-6">
        {data?.title && (
          <h4 className="text-center md:text-left text-2xl md:text-3xl font-semibold">
            {data?.title}
          </h4>
        )}
        {data?.subdata?.length > 0 ? (
          <div className="w-full md:max-h-[calc(734px-22px)] overflow-y-auto border border-shades-05 [&::-webkit-scrollbar]:w-3 [&::-webkit-scrollbar-track]:rounded-none [&::-webkit-scrollbar-track]:bg-gray-100 [&::-webkit-scrollbar-thumb]:rounded-none [&::-webkit-scrollbar-thumb]:bg-chestnut-rose/75">
            <table className="border-collapse w-full">
              <thead className="sticky top-0 bg-white z-[1]">
                <tr className="border-b border-shades-05">
                  {/* <th className="border-l border-shades-05 first:border-l-0 h-16 px-3 text-center w-12">
                    <div className="flex text-2xl font-CanelaDeck gap-2 items-center justify-center">
                      No.
                    </div>
                  </th> */}
                  <th className="border-l border-shades-05 first:border-l-0 h-16 px-3 text-left">
                    <div className="flex text-sm md:text-lg xls:text-2xl font-CanelaDeck gap-2 items-center">
                      Title
                    </div>
                  </th>
                  <th className="border-l border-shades-05 first:border-l-0 h-16 px-3 text-left">
                    <div className="flex text-sm md:text-lg xls:text-2xl font-CanelaDeck gap-2 items-center">
                      Close Date
                    </div>
                  </th>
                  <th className="border-l border-shades-05 first:border-l-0 h-16 px-3 text-left">
                    <div className="flex text-sm md:text-lg xls:text-2xl font-CanelaDeck gap-2 items-center">
                      Details
                    </div>
                  </th>
                  <th className="border-l border-shades-05 first:border-l-0 h-16 px-3 text-left">
                    <div className="flex text-sm md:text-lg xls:text-2xl font-CanelaDeck gap-2 items-center">
                      Actions
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {data?.subdata?.map((item, index) => (
                  <tr
                    key={index}
                    className="border-b border-shades-05 last:border-b-0"
                  >
                    {/* <td className="border-l border-shades-05 first:border-l-0 h-16 px-3 text-center w-12">
                      <div className="flex items-center justify-center font-CanelaDeck text-2xl font-semibold">
                        {String(index + 1).padStart(2, "0")}
                      </div>
                    </td> */}
                    <td className="border-l border-shades-05 first:border-l-0 h-16 px-3 text-left">
                      <div className="flex items-center font-CanelaDeck text-xs md:text-base 2xl:text-xl">
                        {item?.title}
                      </div>
                    </td>
                    <td className="border-l border-shades-05 first:border-l-0 h-16 px-3 text-left">
                      <div className="flex items-center font-CanelaDeck text-xs md:text-base 2xl:text-xl">
                        {item?.date}
                      </div>
                    </td>
                    <td className="border-l border-shades-05 first:border-l-0 h-16 px-3 text-left">
                      <div className="flex items-center font-CanelaDeck text-xs md:text-base xls:text-xl">
                        {item?.viewAction && (
                          <Button
                            buttonHasLink={item?.viewAction?.isLink}
                            buttonFunction={
                              item?.viewAction?.isLink
                                ? () => {}
                                : item?.viewAction?.onClick
                            }
                            buttonLabel={item?.viewAction?.label}
                            buttonClasses={`!h-10 !bg-transparent !px-0 !text-chestnut-rose ${
                              item?.applyAction?.label === "Apply"
                                ? "cursor-pointer"
                                : "cursor-default"
                            }`}
                            buttonLabelClasses={
                              "text-xs md:text-base 2xl:!text-xl !font-CanelaDeck"
                            }
                          />
                        )}
                      </div>
                    </td>

                    <td className="border-l border-shades-05 first:border-l-0 h-16 px-3 text-left">
                      <div className="flex items-center">
                        {item?.applyAction && (
                          <Button
                            buttonHasLink={item?.applyAction?.isLink}
                            buttonFunction={
                              item?.applyAction?.isLink
                                ? () => {}
                                : typeof item?.applyAction?.onClick ===
                                  "function"
                                ? item?.applyAction?.onClick
                                : () => {}
                            }
                            buttonLabel={item?.applyAction?.label}
                            buttonClasses={classNames(
                              "!h-10 !bg-transparent !px-0",
                              !item?.applyAction?.onClick
                                ? "!cursor-default !text-black"
                                : "!text-chestnut-rose"
                            )}
                            buttonLabelClasses={
                              "text-xs md:text-base 2xl:!text-xl !font-CanelaDeck"
                            }
                          />
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
              <tbody>
                <tr>
                  <td colSpan={4}>
                    <div ref={loadMoreRef} className="h-1" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ) : (
          <div>
            <h4 className="text-red-600 font-bold text-lg">
              NO SCHOLARSHIPS AVAILABLE RIGHT NOW — CHECK BACK SOON!
            </h4>
          </div>
        )}
      </div>
    </>
  );
};

export default SectionTable;
